import { render, staticRenderFns } from "./CategoryLegend.vue?vue&type=template&id=66154af2&scoped=true"
import script from "./CategoryLegend.vue?vue&type=script&lang=js"
export * from "./CategoryLegend.vue?vue&type=script&lang=js"
import style0 from "./CategoryLegend.vue?vue&type=style&index=0&id=66154af2&prod&scoped=true&lang=css"
import style1 from "./CategoryLegend.vue?vue&type=style&index=1&id=66154af2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66154af2",
  null
  
)

export default component.exports